module.exports = __webpack_public_path__ + "img/1 (63).d7ccf47f.png";